<template>
  <MitikuinSecccionOne />
  <div class="landing-wrap">
    <!-- CONTENIDO PRINCIPAL -->
    <section class="container py-5 packages-zone" id="paquetes">
      <div class="text-center mb-4">
        <span class="mini-label section-badge">Soluciones digitales 2026</span>
        <h2 class="fw-bold mt-3 mb-3 text-center heading-glow">Servicios y Paquetes</h2>
        <p class="lead text-center mb-4 intro-text">
          Tres niveles para crecer con claridad: desde tu presencia profesional hasta plataformas con automatizacion e inteligencia operativa.
        </p>
        <div class="d-flex flex-wrap justify-content-center gap-2 trust-pills">
          <span class="trust-pill">Diseno orientado a conversion</span>
          <span class="trust-pill">SEO y rendimiento tecnico</span>
          <span class="trust-pill">Escalable a mediano plazo</span>
        </div>
      </div>

      <div class="row g-4 row-cols-1 row-cols-md-2 row-cols-lg-3">
        <div v-for="(p, i) in paquetes" :key="i" class="package-col" :style="{ '--stagger': `${i * 90}ms` }">
          <div class="card h-100 shadow-sm card-glass package-card">
            <div class="card h-100 shadow-sm card-glass card-body d-flex flex-column card-electric text-start">
              <span class="plan-badge">Plan {{ i + 1 }}</span>
              <img src="/assets/img/logo_mitikuinRedondeado.webp" class="img-fluid my-3 ms-auto d-block mockupdown1"
                alt="Logo Mitikuin" width="40" height="40" />
              <div class="d-flex align-items-start justify-content-between mb-2 titlepaq">
                <h2 class="card-title mb-0 intro-text1">{{ p.nombre }} </h2>
                <i class="bi bi-stars text-info fs-5 pulse-star"></i>
              </div>
              <p class="card-subtitle1 mb-2 tagline">{{ p.tagline }}</p>
              <p class="d-flex align-items-start mb-2 featurestitle">{{ p.featurestitle }}</p>
              <ul class="list-unstyled small mt-3 flex-grow-1 intro-text">
                <li v-for="(f, idx) in p.features" :key="idx" class="feature-item d-flex align-items-start mb-2">
                  <span class="icon-wrapper me-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" class="check-icon">
                      <path fill="currentColor"
                        d="M11.102 7.37a.75.75 0 1 0-1.06-1.06L7.54 8.81 6.508 7.78a.75.75 0 0 0-1.06 1.06l1.407 1.408a.968.968 0 0 0 1.37 0l2.877-2.878Z">
                      </path>
                      <path fill="currentColor" fill-rule="evenodd"
                        d="M15 7.995a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
                        clip-rule="evenodd"></path>
                    </svg>
                  </span>
                  <span class="feature-text" v-html="f"></span>
                </li>
              </ul>
              <p class="d-flex align-items-start mb-2 featurestitle">{{ p.caracteristicas }}</p>

              <div class="mt-3 fw-bold price fontsatoshi row mb-3">
                <div class="col-3 text-start">
                  <span class="textdescription"></span>
                </div>
                <div class="col-9 text-center">
                  <span class="textdescription2">{{ p.precio || 'Cotizacion a medida' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>    

    <MitiProjectsCarousel />
    
    <!-- Cierre destacado (sin WhatsApp) -->
    <section class="container pb-5">
      <div class="final-cta card-glass text-center p-4 p-md-5">
        <span class="mini-label">Implementacion profesional</span>
        <h3 class="fw-bold mt-3 mb-3 final-title">Tu proyecto puede iniciar esta semana</h3>
        <p class="mb-4 final-copy">
          Cuentanos lo que necesitas y te preparamos una propuesta clara con alcance, tiempos y costo.
        </p>
        <div class="d-flex flex-wrap justify-content-center gap-2">
          <a href="#hero" class="btn btn-primary btn-lg px-4">Solicitar propuesta</a>
          <a href="https://blog.mitikuin.com/" target="_blank" rel="noopener" class="btn btn-outline-light btn-lg px-4">
            Ver casos y articulos
          </a>
        </div>
      </div>
    </section>

    <MitiPortfolio />
    <MitiFooter />
  </div>
  
</template>

<script setup>
import { ref } from 'vue'
import paquetesData from '@/assets/data/paquetes.json'
import MitikuinSecccionOne from '@/components/MitikuinSecccionOne.vue'
import MitiProjectsCarousel from '@/components/MitiProjectsCarousel.vue'
import MitiFooter from '@/components/MitiFooter.vue'
import MitiPortfolio from '@/components/MitiPortfolio.vue'



// 📦 Ref con los datos del JSON
const paquetes = ref(paquetesData)

</script>

<style scoped>
/* ===== Design tokens & fonts ===== */
:root {
  --tech-cyan: #00e5ff;
  --tech-cyan-2: #38f9ff;
  --tech-blue: #0a2a43;
  --tech-deep: #081822;
  --text-strong: #e9f7ff;
  --text-contrast: #cfe7ff;
}

/* Margen especial para LinkedIn */
.footer-social .linkedin-icon {
  padding-left: 8px;
  padding-right: 8px;
}

@media (max-width: 768px) {
  .footer-social .linkedin-icon {
    padding-right: 18px; /* más separación en móvil */
  }
}

.card-body,
.card-footer {
  padding: 1.8rem;
  background-color: #001933;
  font-family: 'Satoshi', sans-serif !important;
}

.card-footer {
  padding-top: 0;
  padding-bottom: 1.5rem;
}

.card-glass {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  border-radius: 1rem;
}

.packages-zone {
  position: relative;
}

.packages-zone::before {
  content: '';
  position: absolute;
  inset: 10% -5% auto -5%;
  height: 240px;
  background: radial-gradient(55% 70% at 50% 50%, rgba(0, 229, 255, .12), transparent 75%);
  pointer-events: none;
}

.section-badge {
  box-shadow: 0 0 0 1px rgba(255, 255, 255, .12) inset;
}

.trust-pills {
  position: relative;
  z-index: 2;
}

.trust-pill {
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, .22);
  background: rgba(255, 255, 255, .06);
  color: #d8f7ff;
  font-size: .82rem;
  padding: .35rem .78rem;
}

.package-col {
  opacity: 0;
  transform: translateY(18px);
  animation: reveal-card .55s ease forwards;
  animation-delay: var(--stagger);
}

@keyframes reveal-card {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.package-card {
  transition: transform .28s ease, box-shadow .28s ease, border-color .28s ease;
}

.package-card:hover {
  transform: translateY(-8px);
  border-color: rgba(0, 229, 255, .4);
  box-shadow: 0 20px 36px rgba(0, 0, 0, .35), 0 0 24px rgba(0, 229, 255, .16);
}

.plan-badge {
  display: inline-flex;
  align-items: center;
  gap: .35rem;
  width: fit-content;
  border-radius: 999px;
  border: 1px solid rgba(168, 255, 120, .45);
  background: rgba(168, 255, 120, .14);
  color: #eaffd8;
  font-size: .75rem;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
  padding: .28rem .68rem;
}

.pulse-star {
  animation: pulse-star 2.4s ease-in-out infinite;
}

@keyframes pulse-star {
  0%,
  100% {
    transform: scale(1);
    opacity: .8;
  }

  50% {
    transform: scale(1.12);
    opacity: 1;
  }
}

.card-electric {
  border: 2px solid #001933 transparent;
  border-radius: 1em;
  position: relative;
  background-clip: padding-box;
}

.card-electric::before {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 1em;
  z-index: -1;
  background: conic-gradient(from 180deg, var(--tech-cyan), var(--tech-cyan-2), var(--tech-cyan));
  background-size: 200% 200%;
  animation: electric-border 6s linear infinite;
  filter: blur(1px);
}

.intro-text,
.intro-text1 {
  color: #ffffffcb;
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Satoshi', sans-serif !important;
}

.intro-text1 {
  font-weight: bold;
  font-size: 2rem !important;
}

.card-subtitle1 {
  color: #a8ff78 !important;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.tagline {
  color: #b7dfff;
  font-size: .97rem;
}

.price {
  color: #00e5ff;
  font-size: 1.1rem;
}

.titlepaq {
  width: 82%;
}

.featurestitle {
  color: #cfe7ff;
}

.textdescription,
.textdescription2 {
  font-family: 'Satoshi' !important;
  font-weight: bold !important;
  color: #fefefe !important;
}

.textdescription {
  font-size: 1.2rem;
}

.textdescription2 {
  font-size: 1.6rem;
  text-align: center !important;
  text-shadow: 0 0 14px rgba(0, 229, 255, .22);
}

.mockupdown1 {
  margin: 0 0 0 auto !important;
  opacity: 0.4 !important;
}

.final-cta {
  position: relative;
  overflow: hidden;
  border-radius: 1.25rem;
  border: 1px solid rgba(0, 229, 255, .22);
  background:
    radial-gradient(1200px 250px at 50% -30%, rgba(0, 229, 255, .18), transparent 60%),
    linear-gradient(140deg, rgba(8, 24, 34, .96), rgba(13, 43, 63, .96));
  box-shadow: 0 18px 48px rgba(0, 0, 0, .35);
}

.final-cta::after {
  content: '';
  position: absolute;
  inset: auto -25% -65% -25%;
  height: 180px;
  background: radial-gradient(circle, rgba(168, 255, 120, .22), transparent 65%);
  pointer-events: none;
}

.mini-label {
  display: inline-block;
  padding: .4rem .8rem;
  border-radius: 999px;
  font-size: .8rem;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #d6fbff;
  border: 1px solid rgba(255, 255, 255, .22);
  background: rgba(255, 255, 255, .08);
}

.final-title {
  color: #ffffff;
  font-size: clamp(1.5rem, 2.5vw, 2.1rem);
}

.final-copy {
  color: #d7f0ff;
  max-width: 680px;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 768px) {
  .trust-pill {
    font-size: .75rem;
    padding: .32rem .62rem;
  }

  .intro-text1 {
    font-size: 1.6rem !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  .package-col {
    opacity: 1;
    transform: none;
    animation: none;
  }

  .package-card,
  .pulse-star {
    transition: none;
    animation: none;
  }
}
</style>
